<template>
    <!--Portfolio Pictures Container-->
    <section class="portfolio-pictures">
        <div v-if="user && user.role == 'stylist'" class="portfolio-container">
            <div class="portfolio-heading">
                <h2>{{ $t("portfolio.pictures") }}</h2>
            </div>

            <MainLoader v-if="loading" class="section-wrap" />

            <!--Portfolio Images Container-->
            <div v-show="!loading" class="container-wrapper section-wrap">
                <!--Add Image-->
                <div v-on:click="openFileBrowserOverlay(null)" class="portfolio-add-image">
                    <div>
                        <div>
                            <img class="add-portfolio-images pointer" src="../../assets/images/image.svg" />
                        </div>
                        <div class="text-style add-img">
                            <span>+ Add Image</span>
                        </div>
                    </div>
                </div>
                <!--Portfolio Images-->
                <div class="img-inner-container" v-for="(image, index) in portfolioImages" :key="image.id"
                    v-bind:class="{ 'no-padding-bottom': !image.image }">
                    <div class="img-inner">
                        <img v-if="image.image" class="portfolio-images pointer" :data-img-id="image.id"
                            :src="image.image" title="Open Big Picture" loading="lazy" decoding="async"
                            @load="$event.target.classList.add('loaded')" @click.prevent="portfolioImgPreview(image)" />
                    </div>
                    <!--Image Tags-->
                    <div v-if="image.image" class="image-tags-block">
                        <div class="image-tags-wrapper">
                            <input @keydown="onImageTagChange(image, 'tag1')" v-model.trim="image.tag1" type="text"
                                placeholder="Enter tag" class="tag" maxlength="15" />
                            <input @keydown="onImageTagChange(image, 'tag2')" v-model.trim="image.tag2" type="text"
                                placeholder="Enter tag" class="tag" maxlength="15" />
                            <input @keydown="onImageTagChange(image, 'tag3')" v-model.trim="image.tag3" type="text"
                                placeholder="Enter tag" class="tag" maxlength="15" />
                        </div>
                    </div>
                    <!--Image Action Buttons-->
                    <div v-if="image.image" class="portfolio-image-action-block">
                        <div v-on:click="openFileBrowserOverlay(image.id, image)" title="Change Picture"
                            class="image-actions" :class="disableActionClass(image)">
                            <img src="../../assets/images/replace-icon.png" />
                        </div>
                        <div v-on:click="rotateExistingImage(image.id, -90, image)" title="Rotate Left"
                            class="image-actions" :class="disableActionClass(image)">
                            <img class="image-left" src="../../assets/images/rotate-left.svg" alt="Image Left" />
                        </div>
                        <div v-on:click="rotateExistingImage(image.id, 90, image)" title="Rotate Right"
                            class="image-actions" :class="disableActionClass(image)">
                            <img class="image-right" src="../../assets/images/rotate-right.svg" alt="" />
                        </div>
                        <div v-on:click="onDeletePortfolioImage(image)" title="Delete" class="image-actions"
                            :class="disableActionClass(image)">
                            <img class="image-delete" src="../../assets/images/trash-bin.svg" />
                        </div>
                        <div v-if="image.likes > 0" class="image-actions image-action-portfolio-likes"
                            :class="disableActionClass(image)">
                            <img v-if="generalOptions.app_id == 1" class="image-delete" title="Likes"
                                src="../../assets/images/Property1RMS.png" alt="Ring for RMS" />
                            <img v-if="generalOptions.app_id == 2" class="image-delete" title="Likes"
                                src="../../assets/images/RMB.png" alt="Ring for RMS" />
                            <img v-if="generalOptions.app_id == 5" class="image-delete" title="Likes"
                                src="../../assets/images/RMP.png" alt="Ring for RMS" />
                            <div class="image-likes">{{ formatLikes(image.likes) }}</div>
                        </div>
                        <div v-if="
                            (image.tag1change && image.tag1 != '') ||
                            (image.tag2change && image.tag2 != '') ||
                            (image.tag3change && image.tag3 != '')
                        " class="image-actions" title="Save Tags" v-on:click="saveImageTags(image)">
                            <i class="fa fa-floppy-o" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!--Modal for Big Image Preview (Bootstrap 5)-->
            <div class="modal fade" id="image-modal" tabindex="-1" aria-labelledby="image-modal-label"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-body modal-position-wrapper">
                            <button type="button" class="btn-close position-close" data-bs-dismiss="modal"
                                aria-label="Close">
                            </button>
                            <div class="modal-content-big-img">
                                <img id="inner-modal-preview-image" class="img-fluid" alt="Preview Image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Image Upload Overlay-->
            <div v-if="portfolioImageUpload.show">
                <div class="image-upload-overlay"></div>
                <div class="image-upload-overlay-content">
                    <div>
                        <h4 v-if="portfolioImageUpload.index">Change Picture</h4>
                        <h4 v-if="!portfolioImageUpload.index">Add Portfolio Picture</h4>
                    </div>
                    <input class="portfolio-image-input-file" type="file" ref="portfolioImageInputFile" name="img[]"
                        accept="image/*" v-on:change="portfolioImageChange($event)" />
                    <div class="modal-upload">
                        <input type="text" class="selectInput selectInputExtraSmall selectInputSmall" disabled
                            placeholder="Upload File" v-model="portfolioImageUpload.fileName" />
                        <div class="input-group-append">
                            <button v-on:click="openFileBrowser" type="button"
                                class="browse primary-btn primary-btn extra-small mobile">
                                Browse...
                            </button>
                        </div>
                    </div>
                    <div class="portfolio-image-upload-preview" v-if="portfolioImageUpload.preview">
                        <div ref="portfolioImagePreviewContainer" class="preview-image-container">
                            <img :src="portfolioImageUpload.preview" class="portfolio-images loaded"
                                ref="portfolioImagePreview" />
                        </div>
                    </div>
                    <div v-if="portfolioImageUpload.preview" class="image-preview-controls">
                        <div class="image-actions">
                            <div v-on:click="rotateImage('left')" class="image-rotate rotate-left" title="Rotate Left">
                                <img src="../../assets/images/rotate-left.svg" class="image-left" />
                            </div>
                        </div>
                        <div class="image-actions">
                            <div v-on:click="rotateImage('right')" class="image-rotate rotate-right"
                                title="Rotate Right">
                                <img src="../../assets/images/rotate-right.svg" class="fa fa-solid fa-rotate-right" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-btns">
                        <button v-on:click="savePortfolioImageUpload" type="button"
                            class="primary-btn primary-btn extra-small mobile">
                            {{ savingPortfolioImageUpload ? "Saving..." : "Save" }}
                        </button>
                        <button v-on:click="cancelPortfolioImageUpload" type="button"
                            class="secondary-btn small mobile">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import api from "../../services/apiEndpoints.js";
import auth from "./../../services/auth.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";
import $ from "jquery";
import { Modal } from 'bootstrap';
import MainLoader from "../admin/general-components/MainLoader.vue";
import imageCompression from "browser-image-compression";

export default {
    name: "PortfolioPictures",
    data() {
        return {
            user: null,
            portfolioImages: [],
            portfolioImageUpload: {
                show: false,
                index: null, // changed to null by default
                preview: null,
                fileName: null,
                file: null,
                rotate: 0,
                width: 0,
                height: 0,
            },
            savingPortfolioImageUpload: false,
            loading: false,
        };
    },
    mounted() {
        this.user = auth.state.user;
        // eventBus.on("admin_details_loaded", () => {
        //     this.getPortfolioImages();
        // });
        this.getPortfolioImages();
    },
    methods: {
        // IMAGE PREVIEW
        portfolioImgPreview(img) {
            const modalImg = document.getElementById('inner-modal-preview-image');
            modalImg.src = img.image;
            modalImg.setAttribute("data-image-id", img.id);

            const modalElement = document.getElementById('image-modal');
            const bsModal = new Modal(modalElement);
            bsModal.show();
        },

        // FILE BROWSER
        openFileBrowser() {
            this.$refs.portfolioImageInputFile.click();
        },
        openFileBrowserOverlay(index, image) {
            if (
                image &&
                ((image.tag1change && image.tag1 != "") ||
                    (image.tag2change && image.tag2 != "") ||
                    (image.tag3change && image.tag3 != ""))
            ) {
                return;
            }

            this.portfolioImageUpload.index = index;
            this.portfolioImageUpload.show = true;
        },
        portfolioImageChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            const MAX_SIZE_MB = 20;
            const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

            if (file.size >= MAX_SIZE_BYTES) {
                messages.errorMessage(messages.ERROR_MESSAGES.IMAGE_TOO_BIG);
                return;
            }
            this.portfolioImageUpload.file = file;
            this.portfolioImageUpload.fileName = file.name;

            const reader = new FileReader();
            reader.onload = (ev) => {
                this.portfolioImageUpload.preview = ev.target.result;
                setTimeout(() => {
                    const el = $(this.$refs.portfolioImagePreview);
                    this.portfolioImageUpload.width = el.width();
                    this.portfolioImageUpload.height = el.width();
                    this.portfolioImageUpload.rotate = 0;
                }, 200);
            };
            reader.readAsDataURL(file);
        },

        cancelPortfolioImageUpload() {
            this.portfolioImageUpload = {
                index: null,
                show: false,
                fileName: null,
                preview: null,
                file: null,
                rotate: 0,
                width: 0,
                height: 0,
            };
            if (this.$refs.portfolioImageInputFile) this.$refs.portfolioImageInputFile.value = "";
        },

        // RESIZE IMAGE
        async compressImage(file) {
            const options = {
                maxSizeMB: 1,              // max file size in MB
                maxWidthOrHeight: 1200,    // resize if larger than this
                useWebWorker: true,        // improves performance
                fileType: "image/jpeg",    // forces compression to jpeg (smaller size)
                initialQuality: 0.8        // quality fallback
            };

            try {
                const compressedFile = await imageCompression(file, options);
                return compressedFile;
            } catch (error) {
                console.error("Image compression failed:", error);
                return file; // fallback to original if compression fails
            }
        },

        // SAVE IMAGE
        async savePortfolioImageUpload() {
            if (!this.portfolioImageUpload.file || this.savingPortfolioImageUpload) {
                return;
            }

            this.savingPortfolioImageUpload = true;

            try {
                // 🔥 compress before upload
                const file = await this.compressImage(this.portfolioImageUpload.file);

                const formData = new FormData();
                formData.append("image", file);
                formData.append("rotate", this.portfolioImageUpload.rotate);

                // only send ID if editing an existing image
                if (this.portfolioImageUpload.index) {
                    formData.append("id", this.portfolioImageUpload.index);
                }

                const response = await this.$http.post(
                    api.actions.save_portfolio_image,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                if (response.data.error) {
                    messages.errorMessage(response.data.message);
                } else {
                    messages.successMessage(
                        messages.GLOBAL_MESSAGES.PORTFOLIO_IMAGE_CHANGED
                    );
                    this.cancelPortfolioImageUpload();
                    this.getPortfolioImages();
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.savingPortfolioImageUpload = false;
            }
        },

        // ROTATE IMAGE 
        rotateImage(direction) {
            let deg = this.portfolioImageUpload.rotate;
            deg = direction === "left" ? (deg - 90) % 360 : (deg + 90) % 360;
            this.portfolioImageUpload.rotate = deg;

            const el = $(this.$refs.portfolioImagePreview);
            const container = $(this.$refs.portfolioImagePreviewContainer);
            container.css({
                width: this.portfolioImageUpload.width,
                height: this.portfolioImageUpload.height,
                position: "relative",
            });
            el.css({
                transform: `translateX(-50%) translateY(-50%) rotate(${deg}deg)`,
                top: "50%",
                left: "50%",
                position: "absolute",
            });
        },

        rotateExistingImage(id, rotate, image = {}) {
            if (
                (image.tag1change && image.tag1 != "") ||
                (image.tag2change && image.tag2 != "") ||
                (image.tag3change && image.tag3 != "")
            )
                return;

            const data = { id, rotate };
            this.$http.post(api.actions.rotate_portfolio_image, data).then(
                (res) => {
                    if (res.data.error === false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.getPortfolioImages();
                    }
                },
                () => false
            );
        },

        onImageTagChange(image, tag) {
            image[tag + "change"] = true;
        },

        saveImageTags(image) {
            const data = {
                id: image.id,
                firstTag: image.tag1.toLowerCase(),
                secondTag: image.tag2.toLowerCase(),
                thirdTag: image.tag3.toLowerCase(),
            };
            this.$http.post(api.actions.save_image_tags, data).then(
                (res) => {
                    if (res.data.error === false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.IMAGE_TAG_SAVED);
                        this.getPortfolioImages();
                    }
                },
                () => false
            );
        },

        formatLikes(likes) {
            return likes >= 1000 ? (likes / 1000).toFixed(1) + "k" : likes.toString();
        },

        disableActionClass(image) {
            return (image.tag1change && image.tag1 != "") ||
                (image.tag2change && image.tag2 != "") ||
                (image.tag3change && image.tag3 != "")
                ? "disable-icon"
                : "";
        },

        getPortfolioImages() {
            this.loading = true;

            this.$http.get(api.actions.get_portfolio_images)
                .then((res) => {
                    if (res.data.images) {
                        this.portfolioImages = res.data.images
                            .map((img) => ({
                                id: img.id,
                                image: img.image,
                                likes: img.likes,
                                tag1: img.tag1,
                                tag2: img.tag2,
                                tag3: img.tag3,
                                pic_order: img.pic_order,
                            }))
                            .reverse();
                    }
                })
                .catch(() => {
                    // optional: show error
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        onDeletePortfolioImage: function (image) {
            let customClass = "rms-app";
            document.querySelector("body").classList.add("rms-app");

            if (this.generalOptions.app_id === 2) {
                customClass = "rmb-app";
                document.querySelector("body").classList.add("rmb-app");
            } else if (this.generalOptions.app_id === 5) {
                customClass = "rml-app";
                document.querySelector("body").classList.add("rml-app");
            }

            this.$swal({
                title: this.$t("portfolio.confirmQuestion"),
                text: "You won't be able to revert this!",
                confirmButtonColor: "#00cdc1",
                cancelButtonColor: "#07b2c0",
                customClass: customClass,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: this.$t("portfolio.confirmYes"),
                cancelButtonText: this.$t("portfolio.confirmNo"),
            }).then((result) => {
                if (result.value) {
                    this.deletePortfolioImage(image);
                }
            });
        },
        deletePortfolioImage: function (image) {
            let data = {
                id: image.id,
            };
            this.$http.post(api.actions.delete_portfolio_image, data).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.PORTFOLIO_IMAGE_DELETED);
                        this.getPortfolioImages();
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
    },

    components: {
        MainLoader,
    },
};
</script>
